import {
  Config,
  InitApiType,
  EndPointsNames,
  ApiCredentialsType,
  ErrorResponseCodeType,
  REPO_API,
} from '../Core';
import { ListPartnerTypeTypes } from '../Types';

export const API_DOMAIN: EndPointsNames = 'ApiOAG';
export const ENDPOINT_API_PATH = 'lists/partnerType';
export const API_CREDENTIALS_TYPE: ApiCredentialsType = 'TOKEN_AUTH_USER';

export const URL_POSTMAN = `${REPO_API}/1aa3f7db-730f-4a9e-8904-3201cc3d9669/api/7210a7e8-73a2-45a0-9b87-c048466ddeee?version=31e9deda-e2ea-4d4b-becb-e3e5165753fd&tab=overview`;

export const CODE_ERRORS: ErrorResponseCodeType<null>[] = [
  {
    code: '1',
    bussinessErrorVariant: 'errorService',
    message:
      'Ocorreu um erro técnico (Erro inesperado, favor contactar a Smiles)',
  },
];

const definitions = {
  API_DOMAIN,
  ENDPOINT_API_PATH,
  API_CREDENTIALS_TYPE,
  URL_POSTMAN,
  CODE_ERRORS,
};

const callGet = async (
  language: string,
): Promise<ListPartnerTypeTypes.IListPartnerTypeRawServiceResponse> => {
  const init: InitApiType = {
    params: { language },
  };
  return Config.API.get(
    definitions.API_DOMAIN,
    definitions.ENDPOINT_API_PATH,
    definitions.API_CREDENTIALS_TYPE,
    init,
  );
};
const call = { get: callGet };
export default { call, definitions };
